require('../../styles/ai/ai_chat.scss');

const { icon }    = require('@fortawesome/fontawesome-svg-core');
const faIconOpts  = { classes: ['fa-icon'] };
const fa = {
  search: require('@fortawesome/pro-light-svg-icons/faSearch').definition,
  clock: require('@fortawesome/pro-light-svg-icons/faClockRotateLeft').definition
}

module.exports = `
  <div class="ai-chat">
    <div class="chat-preview blurred">
      <div class="div-3">
        <div class="div-wrapper"><p class="text-wrapper">Use AI to query this PDF</p></div>
        <div class="form-input">
          <i class="icon-wrapper">${icon(fa.search, faIconOpts).html}</i>
          <p class="placeholder-text">What would you like to know?</p>
        </div>
      </div>
      <div class="div-3">
        <div class="text-wrapper-2">Suggestions</div>
        <div class="div-4">
          <div class="div-wrapper-2"><div class="text-wrapper-3">Show me related papers</div></div>
          <div class="div-wrapper-2"><div class="text-wrapper-3">Summarize this article</div></div>
          <div class="div-wrapper-2"><div class="text-wrapper-3">What are the main research methods?</div></div>
        </div>
      </div>
      <div class="div-5">
        <div class="text-wrapper-2">Previous queries</div>
        <div class="div-6">
          <div class="icons-recently-wrapper">
            <div class="icon-wrapper">
              <i class="vector">${icon(fa.clock, faIconOpts).html}</i>
            </div>
          </div>
          <p class="p">
            What are the base media that have been used across the endothelial differentiation protocols?
          </p>
        </div>
      </div>
    </div>
  </div>
`;
